import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import security from '../../../js/pages/JobsListPage/securityJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={security} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(security);
export const getStaticPaths = makeStaticPaths(security);
